import React from "react";
import { Grid, Skeleton } from "@mui/material";

type HitsGridSkeletonProps = {
  items?: number;
};

const HitsGridSkeleton: React.FunctionComponent<any> = (props): JSX.Element => {
  const { items = 9 }: HitsGridSkeletonProps = props;
  return (
    <Grid container spacing={2} mt="1rem">
      {[...Array(items)].map((e, i) => {
        return (
          <Grid key={`hit-skeleton-${i}`} item xs={12} sm={6} md={4} lg={4} xl={4} minHeight={344} height="auto">
            <Skeleton variant="rectangular" width="100%" height={344} />
          </Grid>
        );
      })}
      <Grid item xs={12}>
        <Skeleton variant="rectangular" width="100%" height={9} />
      </Grid>
    </Grid>
  );
};

export default React.memo(HitsGridSkeleton);
